import { useTranslation } from 'react-i18next';
import { useApiMutation } from '../../../hooks/useApiMutation';
import { saveTemplate } from '../api/logbookApi';
import { UseApiMutationOptions } from '../types/loogBookTypes';

type MutationResponse = { message: string };
type MutationVariables = FormData;

/**
 * [Responsibility: API Mutation]
 * A dedicated hook for creating or updating a logbook template via the API.
 * It wraps the generic `useApiMutation` hook with specific types and API function.
 * @param options - Configuration options (e.g., onSuccess, successMessage) for the mutation.
 */
export const useCreateOrUpdateLogbookTemplate = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>
) => {
  const { t } = useTranslation();
  return useApiMutation<MutationResponse, Error, MutationVariables>(saveTemplate, {
    errorMessage: t('logbook.templates.saveFailed', 'Failed to save logbook template'),
    invalidateQueryKeys: [['logbookTemplates']],
    ...options,
  });
};